import { TeaserBackground } from './teasers/TeaserBackground'
import { TeaserBackgroundLg } from './teasers/TeaserBackgroundLg'
import { TeaserBackgroundRelated } from './teasers/TeaserBackgroundRelated'
import { TeaserBackgroundRelatedLg } from './teasers/TeaserBackgroundRelatedLg'
import { TeaserChargeLg } from './teasers/TeaserChargeLg'
import { TeaserChargeMd } from './teasers/TeaserChargeMd'
import { TeaserChargeSm } from './teasers/TeaserChargeSm'
import { TeaserColumnist } from './teasers/TeaserColumnist'
import { TeaserEditais } from './teasers/TeaserEditais'
import { TeaserEditorial } from './teasers/TeaserEditorial'
import { TeaserEditorialSm } from './teasers/TeaserEditorialSm'
import { TeaserHeadlineSm } from './teasers/TeaserHeadlineSm'
import { TeaserHeadlineLg } from './teasers/TeaserHeadlineLg'
import { TeaserImageLeft } from './teasers/TeaserImageLeft'
import { TeaserImageLeftSq } from './teasers/TeaserImageLeftSq'
import { TeaserImageLeftSm } from './teasers/TeaserImageLeftSm'
import { TeaserImageLeftLg } from './teasers/TeaserImageLeftLg'
import { TeaserNoImage } from './teasers/TeaserNoImage'
import { TeaserCard } from './teasers/TeaserCard'
import { TeaserCardBold } from './teasers/TeaserCardBold'
import { TeaserImageTop } from './teasers/TeaserImageTop'
import { TeaserImageTopLg } from './teasers/TeaserImageTopLg'
import { TeaserImageBottom } from './teasers/TeaserImageBottom'
import { TeaserImageLeftXl } from './teasers/TeaserImageLeftXl'
import { TeaserMostRead } from './teasers/TeaserMostRead'
import { TeaserMostReadFixed } from './teasers/TeaserMostReadFixed'
import { TeaserPodcast } from './teasers/TeaserPodcast'
import { TeaserRelated } from './teasers/TeaserRelated'
import { TeaserRadio } from './teasers/TeaserRadio'
import { TeaserStories } from './teasers/TeaserStories'
import { TeaserVideoFeatured } from './teasers/TeaserVideoFeatured'
import { TeaserVideoFeatSm } from './teasers/TeaserVideoFeatSm'
import { TeaserVideoFeatMd } from './teasers/TeaserVideoFeatMd'
import { TeaserVideoFeatLg } from './teasers/TeaserVideoFeatLg'
import { TeaserVideoLeft } from './teasers/TeaserVideoLeft'
import { TeaserVideoTop } from './teasers/TeaserVideoTop'

const teasers = {
  TeaserBackground,
  TeaserBackgroundLg,
  TeaserBackgroundRelatedLg,
  TeaserBackgroundRelated,
  TeaserChargeLg,
  TeaserChargeMd,
  TeaserChargeSm,
  TeaserEditais,
  TeaserEditorial,
  TeaserEditorialSm,
  TeaserImageBottom,
  TeaserImageLeft,
  TeaserImageLeftSq,
  TeaserImageLeftSm,
  TeaserImageLeftLg,
  TeaserImageLeftXl,
  TeaserImageTop,
  TeaserImageTopLg,
  TeaserCard,
  TeaserCardBold,
  TeaserColumnist,
  TeaserRelated,
  TeaserHeadlineSm,
  TeaserHeadlineLg,
  TeaserNoImage,
  TeaserMostRead,
  TeaserMostReadFixed,
  TeaserPodcast,
  TeaserRadio,
  TeaserStories,
  TeaserVideoFeatured,
  TeaserVideoFeatSm,
  TeaserVideoFeatMd,
  TeaserVideoFeatLg,
  TeaserVideoLeft,
  TeaserVideoTop,
}

export const teasersArray: string[] = Object.keys(teasers)

export type teaserTypes = typeof teasersArray[number]

export { teasers }
